import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Type } from '../models/type.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypeService {

  constructor(private http: HttpClient) {}

  getAllTypes(): Observable<Type[]> {
    return this.http.get<Type[]>(environment.api_service_types);
  }

  getTypeById(id: string): Observable<Type> {
    return this.http.get<Type>(`${environment.api_service_types}/${id}`);
  }

  createType(department: Type): Observable<Type> {
    return this.http.post<Type>(environment.api_service_types, department);
  }

  updateType(id: string, department: Type): Observable<Type> {
    return this.http.put<Type>(`${environment.api_service_types}/${id}`, department);
  }

  deleteType(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.api_service_types}/${id}`);
  }
}
